const WebsiteConfig = {
    'haoxi123': {
        fullName: '天津一台好戏文化传媒有限公司',
        shortName: '一台好戏',
        icp: '津ICP备2024015367号-2 ｜ ICP经营许可证：津ICP备2024015367号',
        email: 'yitaihaoxi@163.com',
        address: '天津市河东区创智大厦1-2316',
        postcode: '300011',
        appFilter: '\\"goodPlayOnline\\":true',
    },
    'hanweiwl': {
        fullName: '广州浛溦网络科技有限公司',
        shortName: '浛溦',
        icp: '粤ICP备2025381103号',
        email: 'gzhanwei2025@163.com',
        address: '广州市天河区龙洞商贸大街12号101铺、14号101铺N039',
        postcode: '510620',
        appFilter: '\\"hanweiOnline\\":true',
    },
    'gzmenghuo': {
        fullName: '广州梦火网络科技有限公司',
        shortName: '梦火',
        icp: '粤ICP备2025500565号-1',
        email: 'gzmenghuo2025@163.com',
        address: '广州市天河区石牌西海欣街2,4,6,8号二楼E112号',
        postcode: '510630',
        appFilter: '\\"menghuoOnline\\":true',
    },
    'cdruijie': {
        fullName: '成都锐捷网络科技有限公司',
        shortName: '锐捷',
        icp: '蜀ICP备2025175988号-1',
        email: 'cdruijie2025@163.com',
        address: '四川省成都市成华区和顺西一路9号2栋1单元3层307号',
        postcode: '610066',
        appFilter: '\\"ruijieOnline\\":true',
    },
    'meehuan': {
        fullName: '广州密幻网络科技有限公司',
        shortName: '密幻',
        icp: '粤ICP备2022062133号-1',
        email: 'mihuan-op@foxmail.com',
        address: '广州市天河区华夏路32号3002房',
        postcode: '510623',
        appFilter: '\\"mihuanOnline\\":true',
    },
    'gzchiliu': {
        fullName: '广州炽流网络科技有限公司',
        shortName: '炽流',
        icp: '粤ICP备2026046876号',
        email: 'gzchiliu2026@163.com',
        address: '广州市天河区灵山东路3号701室（部位：1-8）自编E066号',
        postcode: '510665',
        appFilter: '\\"chiliuOnline\\":true',
    },
    'gzyoulanwl': {
        fullName: '广州忧斓网络科技有限公司',
        shortName: '忧斓',
        icp: '粤ICP备2026086825号-1',
        email: 'gzyoulan2026@163.com',
        address: '广州市天河区先烈东路190号四层L058房',
        postcode: '510599',
        appFilter: '\\"youlanOnline\\":true',
    },
    'yunzhouwl': {
        fullName: '广州昀舟网络科技有限公司',
        shortName: '昀舟',
        icp: '粤ICP备2026086826号-1',
        email: 'gzyunzhou2026@163.com',
        address: '广州市天河区体育东路140-148号2205房A720室',
        postcode: '510620',
        appFilter: '\\"yunzhouOnline\\":true',
    },
    'gzhengtuowl': {
        fullName: '广州蘅拓网络有限公司',
        shortName: '蘅拓',
        icp: '粤ICP备2026087818号-1',
        email: 'gzhengtuo2026@163.com',
        address: '广州市天河区龙口西路1号708房C113室',
        postcode: '510635',
        appFilter: '\\"hengtuoOnline\\":true',
    },
    'gzhengyuwl': {
        fullName: '广州蘅宇网络科技有限公司',
        shortName: '蘅宇',
        icp: '粤ICP备2026112381号',
        email: 'gzhengyu2026@163.com',
        address: '广州市天河区中山大道358号大院自编4号楼一楼B176',
        postcode: '510000',
        appFilter: '\\"hengyuOnline\\":true',
    },
    'gzchirewl': {
        fullName: '广州驰热网络科技有限公司',
        shortName: '驰热',
        icp: '粤ICP备2026112344号',
        email: 'gzchire2026@126.com',
        address: '广州市天河区高科路32,34号B1栋3层305、310、311房P1127',
        postcode: '510520',
        appFilter: '\\"chireOnline\\":true',
    },
    'gzhengsuwl': {
        fullName: '广州恒溯网络科技有限公司',
        shortName: '恒溯',
        icp: '粤ICP备2026128774号-1',
        email: 'gzhengsu2026@163.com',
        address: '广州市天河区天源路1045号1047号201房211、213号A1821号',
        postcode: '510520',
        appFilter: '\\"hengsuOnline\\":true',
    },
}

const host = location.host;
const key = Object.keys(WebsiteConfig).find(key => host.includes(key));
const websiteConfig = WebsiteConfig[key] || WebsiteConfig['meehuan'];
const meta = document.createElement('meta');
meta.name = 'author';
meta.content = websiteConfig.fullName;
document.head.appendChild(meta);

websiteConfig.logo = `logo/${websiteConfig.shortName}.png`;

export default websiteConfig;